// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid-row","root":"grid-row-m__root__NKTOq"};